import { IColumn } from '../types';
import { defaultHeaderRenderer } from '../headers';
import { hasPerm, P } from '../../../../../utilities/roles/permissions';
import { getUniFullName } from '../../../../../utilities/formatting';
import { Tooltip } from '@chakra-ui/react';
import { LeftAlign } from '../styles';
import { CellEventsHandler } from '../formatters';
import { CellProps } from '../../types';

const UniFormatter = (cellProps: CellProps) => {
  const alignedValue = <LeftAlign>{cellProps.row.uni}</LeftAlign>;
  const uniFullName = getUniFullName(cellProps.row.uni);
  if (uniFullName) {
    return (
      <CellEventsHandler cellProps={cellProps}>
        <Tooltip hasArrow placement="top" label={uniFullName}>
          {alignedValue}
        </Tooltip>
      </CellEventsHandler>
    );
  }
  return <CellEventsHandler cellProps={cellProps}>{alignedValue}</CellEventsHandler>;
};

export const UniColumn = (): IColumn => ({
  item: {
    key: 'uni',
    name: 'Uni',
    headerRenderer: defaultHeaderRenderer,
    sortable: true,
    width: 'minmax(64px, .5fr)',
    formatter: UniFormatter,
  },
  visible: ({ role, isPathway, isServiceProvider, isImmigrationProvidersVisible }) => {
    return (
      hasPerm(role, P.UNIVERSITY_VIEW) ||
      isPathway ||
      (isServiceProvider ?? false) ||
      (isImmigrationProvidersVisible ?? false)
    );
  },
});
